import { Injectable } from '@angular/core';
import { Http } from '@core/http/http';
import { INotPlantedReportsLineItem, IPlantingReportsLineItem } from '@reporting/interfaces';
import { environment } from '@app/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SnapshotService {

    constructor(private http: Http) { }

    public CreateSnapshotPlantingReport(request: IPlantingReportsLineItem[]): Observable<boolean> {
        return this.http.post(`${environment.apiRoot}api/v1/CreateSnapshot/PlantingReport`, request);
    }

    public CreateSnapshotNotPlantedReport(request: INotPlantedReportsLineItem[]): Observable<boolean> {
        return this.http.post(`${environment.apiRoot}api/v1/CreateSnapshot/NotPlantedReport`, request);
    }
}
